/* Skullette FALL CLEARANCE — sticky checkout bar: "⏱ 58:10 left · 2 items · $58.90 · Checkout →". Last 5 minutes of
 * the shopper's personal 60-min window → bar turns red with "4:59 left — check out to keep your picks". Shows
 * whenever the cart has items during the 'live' phase. Repaints from 'sfc:added' (cart from the Horizon module,
 * no extra GET) or Horizon 'cart:update' (drawer qty change/remove → debounced GET /cart.js). Needs window.SFC. */
(function () {
  var A = window.SFC;
  if (!A) return;
  var root = A.root;
  var bar = root.querySelector('[data-sfc-bar]');
  if (!bar) return;
  var tEl = bar.querySelector('[data-sfc-bar-t]');
  var timer = null;

  function paint(cart) {
    if (!cart) return;
    var n = cart.item_count || 0;
    bar.hidden = n < 1 || A.phase() !== 'live';
    root.classList.toggle('has-bar', !bar.hidden);
    if (bar.hidden) return;
    var last5 = A.lastFiveMin();
    bar.classList.toggle('is-last5', last5);
    var left = A.mmss(A.remainMs());
    tEl.innerHTML = last5
      ? '<b>' + left + '</b> left — check out to keep your picks'
      : '⏱ <b>' + left + '</b> left · ' + n + (n === 1 ? ' item' : ' items') + ' · <b>' + A.money((cart.total_price || 0) / 100) + '</b>';
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 150);
  }

  root.addEventListener('sfc:added', function (e) { if (e.detail && e.detail.cart) paint(e.detail.cart); else refresh(); });
  document.addEventListener('cart:update', refresh);
  setInterval(function () { if (!bar.hidden) refresh(); }, 15000); // keeps "N left" honest through the last 5 min
  refresh();
})();
